import { FixMessage } from "./FixMessage";
import { toTitleCase } from "../../Utils";

export class FixTag {
  readonly message: FixMessage;
  readonly num: number;
  readonly value: string;
  type: any;
  group = false;
  errors: string[] = [];
  warnings: string[] = [];
  senderCompId = "";
  senderSubId = "";
  targetCompId = "";
  targetSubId = "";

  /**
   * FixTag.
   *
   * @param m
   * @param c
   * @param v
   * @constructor
   */
  constructor(m: FixMessage, c: number, v: string) {
    this.message = m;
    this.num = c;
    this.value = v;
  }

  getDescription() {
    if (!!this.type && !!this.type.v && this.value in this.type.v)
      return toTitleCase(this.type.v[this.value]);
    return "";
  }

  getTagName(): string | undefined {
    if (this.type === undefined) return undefined;
    return this.type.n;
  }

  isValid(): boolean {
    return this.errors.length + this.warnings.length === 0;
  }

  isHeaderTag(): boolean {
    if (this.type === undefined || !this.message.dictionary) return false;
    return this.message.dictionary.isHeaderTag(this.num);
  }

  isTrailerTag(): boolean {
    if (this.type === undefined || !this.message.dictionary) return false;
    return this.message.dictionary.isTrailerTag(this.num);
  }

  isGroupHeader(): boolean {
    if (this.type === undefined || !this.message.dictionary) return false;
    return this.message.dictionary.isGroupHeader(
      this.message.msgType?.value || "",
      this.num
    );
  }

  isGroup(): boolean {
    if (this.type === undefined || !this.message.dictionary) return false;
    return this.message.dictionary.isGroupTag(
      this.message.msgType?.value || "",
      this.num
    );
  }

  isGroupStart(): boolean {
    if (this.type === undefined || !this.message.dictionary) return false;
    return this.message.dictionary.isGroupStart(
      this.message.msgType?.value,
      this.num
    );
  }
}
